module.exports = __webpack_public_path__ + "8c494a498e726ed21048eae5a33fa5bf.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gewonnen_level_4_opgewekt.mp3
// module id = 97
// module chunks = 0